// forms
import { AuthenticationState } from '../../redux/authentication/authenticationModels'
import authenticationReducer from '../../redux/authentication/authenticationReducer'
import { LogsReducer } from '../../redux/logs-ts/logsModels'
import addUserFormReducer, { AddUserFormReducerState } from './@forms/addUserForm/addUserFormReducer'
import exportLeaveOfAbsencesFormReducer, {
    ExportLeaveOfAbsencesFormReducerState,
} from './@forms/exportLeaveOfAbsencesForm/exportLeaveOfAbsencesFormReducer'
import shiftSnapshotFormReducer, { ShiftSnapshotFormState } from './@forms/shiftSnapshotForm/shiftSnapshotReducer'
// interfaces
import calendarReducer, { CalendarState } from './@interface/calendar/calendarReducer'
import globalFiltersReducer, { GlobalFiltersState } from './@interface/globalFilters/globalFiltersReducer'
import helpReducer, { HelpState } from './@interface/help/helpReducer'
import notificationsReducer, { NotificationsState } from './@interface/notifications/notificationsReducer'
import optionsReducer, { OptionsState } from './@interface/options/optionsReducer'
// other
import pacoAbsencesReducer, { AbsencesState } from './absences/absencesReducer';
import authenticatedUserReducer, { AuthenticatedUserState } from './authenticatedUser/authenticatedUserReducer';
import pacoBaseScheduleReducer, { BaseScheduleState } from './baseSchedule/baseScheduleReducer';
import pacoBaseScheduleShiftReducer, { BaseScheduleShiftState } from './baseScheduleShift/baseScheduleShiftReducer';
import pacoBaseScheduleShiftPlanningReducer, { BaseScheduleShiftPlanningState } from './baseScheduleShiftPlanning/baseScheduleShiftPlanningReducer'
import { changeLogEntriesReducer, ChangeLogEntriesState } from './changeLogEntries/changeLogEntriesReducer'
import { changeLogEntryReducer, ChangeLogEntryState } from './changeLogEntry/changeLogEntryReducer'
import completePeriodsReducer, { CompletePeriodsState } from './completePeriods/completePeriodsReducer';
import conceptDayCommentsReducer, { ConceptDayCommentsState } from './conceptDayComments/ConceptDayCommentsReducer';
import contractHoursReducer, { ContractHoursState } from './contractHours/contractHoursReducer';
import dashboardSettingsReducer, { DashboardState } from './dashboard/dashboardReducer';
import departmentGroupsReducer, { DepartmentGroupsState } from './departmentGroups/departmentGroupsReducer';
import pacoDepartmentsReducer, { DepartmentsState } from './departments/departmentsReducer'
import districtDivisionReducer, { DistrictDivisionState } from './districtDivision/districtDivisionReducer';
import districtDivisionDistrictPlanningReducer, { DistrictDivisionDistrictPlanningState } from './districtDivisionDistrictPlanning/districtDivisionDistrictPlanningReducer';
import districtDivisionGroupTemplateReducer, { DistrictDivisionGroupTemplateState } from './districtDivisionGroupTemplate/districtDivisionGroupTemplateReducer';
import districtDivisionTemplateReducer, { DistrictDivisionTemplateState } from './districtDivisionTemplate/districtDivisionTemplateReducer';
import districtDivisionTemplatesReducer, { DistrictDivisionTemplatesState } from './districtDivisionTemplates/districtDivisionTemplatesReducer';
import divergentPostEmploymentHourReducer, { DivergentPostEmploymentHourState } from './divergentPostEmploymentHour/divergentPostEmploymentHourReducer';
import divergentPreEmploymentHourReducer, { DivergentPreEmploymentHourState } from './divergentPreEmploymentHour/divergentPreEmploymentHourReducer';
import dropboxReducer, { DropboxState } from './dropbox/dropboxReducer';
import employmentTypesReducer, { EmploymentTypesState } from './employmentTypes/employmentTypesReducer';
import eventLogsReducer, { EventLogsState } from './eventLogs/eventLogsReducer';
import exchangesReducer, { ExchangesState } from './exchanges/exchangesReducer';
import experiencesReducer, { ExperiencesState } from './experiences/experiencesReducer'
import filesReducer, { FilesState } from './files/filesReducer';
import hourBalancesReducer, { HourBalancesState } from './hourBalances/hourBalancesReducer';
import pacoLeaveOfAbsencesReducer, { LeaveOfAbsencesState } from './leaveOfAbsences/leaveOfAbsencesReducer';
import leaveOfAbsencesOverviewReducer, { LeaveOfAbsencesOverviewState } from './leaveOfAbsencesOverview/leaveOfAbsencesOverviewReducer';
import pacoPayrollPeriodsReducer, { PayrollPeriodsState } from './payrollPeriods/payrollPeriodsReducer';
import pzLogCategoriesReducer, { PzLogCategoriesState } from './pzLogCategories/pzLogCategoriesReducer';
import pzLogsReducer, { PzLogsState } from './pzLogs/pzLogsReducer';
import rolesReducer, { RolesState } from './roles/rolesReducer';
import pacoSettingsReducer, { SettingsState } from './settings/settingsReducer';
import shiftReducer, { ShiftState } from './shift/shiftReducer';
import pacoShiftConceptReducer, { ShiftConceptState } from './shiftConcept/shiftConceptReducer';
import shiftConceptPlanningReducer, { ShiftConceptPlanningState } from './shiftConceptPlanning/shiftConceptPlanningReducer';
import shiftDetailReducer, { ShiftDetailState } from './shiftDetail/shiftDetailReducer';
import shiftPlanningReducer, { ShiftPlanningState } from './shiftPlanning/shiftPlanningReducer';
import shiftsCalendarReducer, { ShiftsCalendarState } from './shiftsCalendar/shiftsCalendarReducer';
import pacoSpecialDaysReducer, { SpecialDaysState } from './specialDays/specialDaysReducer';
import temporaryWorkerReducer, { TemporaryWorkerState } from './temporaryWorker/temporaryWorkerReducer';
import toastsReducer, { ToastsState } from './toasts/toastsReducer';
import pacoTracksReducer, { TracksState } from './tracks/tracksReducer';
import transportationOptionsReducer, { TransportationOptionsState } from './transportationOptions/transportationOptionsReducer';
import pacoUserReducer, { UserState } from './user/userReducer';
import pacoUsersReducer, { UsersState } from './users/usersReducer';
import usersOverviewReducer, { UsersOverviewState } from './usersOverview/usersOverviewReducer';
import usersWithDivergentEmploymentHoursReducer, { UsersWithDivergentEmploymentHoursState } from './usersWithDivergentEmploymentHours/usersWithDivergentEmploymentHoursReducer';
import { valkTalkPostReducer, ValkTalkPostState } from './valkTalkPost/valkTalkPostReducer';
import { valkTalkPostsReducer, ValkTalkPostsState } from './valkTalkPosts/valkTalkPostsReducer';
import workweekUsersReducer, { WorkweekUsersState } from './workweekUsers/workweekUsersReducer';
import yearEndStatementReducer, { YearEndStatementsState } from './yearEndStatement/yearEndStatementReducer';

export interface Reducers {
    pacoAbsencesReducer: AbsencesState;
    addUserFormReducer: AddUserFormReducerState;
    authenticatedUserReducer: AuthenticatedUserState;
    authenticationReducer: AuthenticationState;
    calendarReducer: CalendarState;
    changeLogEntriesReducer: ChangeLogEntriesState;
    changeLogEntryReducer: ChangeLogEntryState;
    completePeriodsReducer: CompletePeriodsState;
    conceptDayCommentsReducer: ConceptDayCommentsState;
    contractHoursReducer: ContractHoursState;
    dashboardSettingsReducer: DashboardState;
    pacoDepartmentsReducer: DepartmentsState;
    departmentGroupsReducer: DepartmentGroupsState;
    districtDivisionDistrictPlanningReducer: DistrictDivisionDistrictPlanningState;
    districtDivisionGroupTemplateReducer: DistrictDivisionGroupTemplateState;
    districtDivisionReducer: DistrictDivisionState;
    districtDivisionTemplateReducer: DistrictDivisionTemplateState;
    districtDivisionTemplatesReducer: DistrictDivisionTemplatesState;
    divergentPostEmploymentHourReducer: DivergentPostEmploymentHourState;
    divergentPreEmploymentHourReducer: DivergentPreEmploymentHourState;
    dropboxReducer: DropboxState;
    employmentTypesReducer: EmploymentTypesState;
    eventLogsReducer: EventLogsState;
    exchangesReducer: ExchangesState;
    experiencesReducer: ExperiencesState;
    filesReducer: FilesState;
    exportLeaveOfAbsencesFormReducer: ExportLeaveOfAbsencesFormReducerState;
    globalFiltersReducer: GlobalFiltersState;
    helpReducer: HelpState;
    hourBalancesReducer: HourBalancesState;
    leaveOfAbsencesOverviewReducer: LeaveOfAbsencesOverviewState;
    logsReducer: LogsReducer;
    notificationsReducer: NotificationsState;
    optionsReducer: OptionsState;
    pacoBaseScheduleReducer: BaseScheduleState;
    pacoBaseScheduleShiftReducer: BaseScheduleShiftState;
    pacoBaseScheduleShiftPlanningReducer: BaseScheduleShiftPlanningState;
    pacoLeaveOfAbsencesReducer: LeaveOfAbsencesState;
    pacoPayrollPeriodsReducer: PayrollPeriodsState;
    pacoSettingsReducer: SettingsState;
    pacoShiftConceptReducer: ShiftConceptState;
    pacoSpecialDaysReducer: SpecialDaysState;
    pacoUserReducer: UserState;
    pacoUsersOverviewReducer: UsersOverviewState;
    pacoTracksReducer: TracksState;
    pacoUsersReducer: UsersState;
    pzLogCategoriesReducer: PzLogCategoriesState;
    pzLogsReducer: PzLogsState;
    rolesReducer: RolesState;
    shiftConceptPlanningReducer: ShiftConceptPlanningState;
    shiftDetailReducer: ShiftDetailState;
    shiftPlanningReducer: ShiftPlanningState;
    shiftReducer: ShiftState;
    shiftsCalendarReducer: ShiftsCalendarState;
    shiftSnapshotFormReducer: ShiftSnapshotFormState;
    temporaryWorkerReducer: TemporaryWorkerState;
    toastsReducer: ToastsState;
    transportationOptionsReducer: TransportationOptionsState;
    usersWithDivergentEmploymentHoursReducer: UsersWithDivergentEmploymentHoursState;
    valkTalkPostReducer: ValkTalkPostState;
    valkTalkPostsReducer: ValkTalkPostsState;
    workweekUsersReducer: WorkweekUsersState;
    yearEndStatementReducer: YearEndStatementsState;
}

export default {
    pacoAbsencesReducer,
    addUserFormReducer,
    authenticatedUserReducer,
    authenticationReducer,
    calendarReducer,
    changeLogEntriesReducer,
    changeLogEntryReducer,
    completePeriodsReducer,
    conceptDayCommentsReducer,
    contractHoursReducer,
    dashboardSettingsReducer,
    pacoDepartmentsReducer,
    departmentGroupsReducer,
    districtDivisionDistrictPlanningReducer,
    districtDivisionGroupTemplateReducer,
    districtDivisionReducer,
    districtDivisionTemplateReducer,
    districtDivisionTemplatesReducer,
    divergentPostEmploymentHourReducer,
    divergentPreEmploymentHourReducer,
    dropboxReducer,
    employmentTypesReducer,
    eventLogsReducer,
    exchangesReducer,
    experiencesReducer,
    filesReducer,
    exportLeaveOfAbsencesFormReducer,
    globalFiltersReducer,
    helpReducer,
    hourBalancesReducer,
    leaveOfAbsencesOverviewReducer,
    notificationsReducer,
    optionsReducer,
    pacoBaseScheduleReducer,
    pacoBaseScheduleShiftReducer,
    pacoBaseScheduleShiftPlanningReducer,
    pacoLeaveOfAbsencesReducer,
    pacoSettingsReducer,
    pacoShiftConceptReducer,
    pacoSpecialDaysReducer,
    pacoPayrollPeriodsReducer,
    pacoTracksReducer,
    pacoUserReducer,
    usersOverviewReducer,
    pacoUsersReducer,
    pzLogCategoriesReducer,
    pzLogsReducer,
    rolesReducer,
    shiftConceptPlanningReducer,
    shiftDetailReducer,
    shiftPlanningReducer,
    shiftReducer,
    shiftsCalendarReducer,
    shiftSnapshotFormReducer,
    temporaryWorkerReducer,
    toastsReducer,
    transportationOptionsReducer,
    usersWithDivergentEmploymentHoursReducer,
    valkTalkPostReducer,
    valkTalkPostsReducer,
    workweekUsersReducer,
    yearEndStatementReducer,
}
